import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors, opacities, statusColors } from '../../../defaultTheme';
import Button from '../../atoms/Button';
export const ToastBody = styled.div `
  color: ${({ type }) => statusColors[type || 'info'].font};
`;
export const IconWrapper = styled.div `
  color: ${({ type }) => statusColors[type || 'info'].icon};
  height: 24px;
  width: 24px;
  min-width: 24px;
  margin-right: 16px;
`;
export const LeftBar = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 8px;
  height: 100%;
  border-radius: 6px 0 0 6px;
  background-color: ${({ type }) => statusColors[type || 'info'].icon};
`;
export const ToastCloseButton = styled(Button) `
  margin: 0;
  padding: 0;
  width: 20px;
  margin-left: 24px;
`;
export const ToastCloseIcon = styled(FontAwesomeIcon) `
  fill: ${colors.steelGray};
`;
export const Container = styled.div `
  position: relative;
  border-radius: 6px;
  padding: 16px 20px 16px 24px;
  border: 1px solid ${({ type }) => statusColors[type || 'info'].border};
  border-left: none;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  background-color: ${({ type }) => statusColors[type || 'info'].background};
  box-shadow: ${({ hasShadow }) => hasShadow
    ? `0 4px 5px 0 ${opacities.rgbaLight10}, 0 3px 14px 3px ${opacities.rgbaLight08}, 0 8px 10px 1px ${opacities.rgbaLight04}`
    : null};
`;
//# sourceMappingURL=subcomponents.js.map